import React from 'react';
import { CTAButton } from './CTAButton';
import { finalSection } from '../data/copy';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME, PRODUCT_SUBTITLE, PRODUCT_TAGLINE } from './constants';
export function FinalCTA() {
  return <section className="bg-pf-navy px-3 py-3 text-white sm:px-4 sm:py-4" data-id="element-58" data-mp="85fc0zc93r28">
      <div className="mx-auto max-w-3xl text-center" data-id="element-59" data-mp="87jrmejiieic">
        <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-60" data-mp="m3wzcvy8v1jm">
          {finalSection.title}
        </h2>
        <p className="mb-1 text-[12.5px] font-bold leading-snug text-white sm:text-lg" data-id="element-61" data-mp="vv9pnj4e9jnj">
          {finalSection.lead}
        </p>
        <div className="mx-auto mb-1 max-w-2xl space-y-0.5 text-[12px] font-medium leading-snug text-white/75 sm:text-base" data-id="element-62" data-mp="qwztb56xod0c">
          {finalSection.lines.map(line => <p key={line} data-id="element-63" data-mp="zwv7zjzp6q54">{line}</p>)}
        </div>
        <p className="text-[12.5px] font-bold text-white sm:text-base" data-id="element-64" data-mp="zua830iymka0">{finalSection.pivot}</p>
        <p className="font-display text-[14px] font-extrabold uppercase text-pf-gold sm:text-2xl" data-id="element-65" data-mp="2c6rb08eaaeo4">
          {finalSection.system}
        </p>
        <ul className="mx-auto my-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[12px] font-bold text-white sm:text-[15px]" data-id="element-66" data-mp="2m2b0abycef3w">
          {finalSection.actions.map(action => <li key={action} data-id="element-67" data-mp="2v4257el26hwp">{action}</li>)}
        </ul>
        <p className="mb-1.5 text-[12.5px] font-medium text-white/80 sm:text-base" data-id="element-68" data-mp="2v1ochcduphsb">
          {finalSection.close}
        </p>

        <a href={CHECKOUT_URL} className="mb-1.5 block" aria-label={`Buy ${PRODUCT_NAME}`} data-id="element-69" data-mp="34ssivnpgnubj">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[200px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-70" data-mp="39s5ccrau7zn3" />
        </a>

        <p className="font-display text-[19px] font-extrabold uppercase leading-none tracking-tight text-white sm:text-4xl" data-id="element-71" data-mp="3itmq430rvp8m">
          🤰 {PRODUCT_NAME}
        </p>
        <p className="font-display text-[11px] font-bold uppercase text-pf-gold sm:text-base" data-id="element-72" data-mp="1eq1ns23kwnds">
          {PRODUCT_TAGLINE}
        </p>
        <p className="mb-1 text-[11.5px] font-semibold text-white/80 sm:text-base" data-id="element-73" data-mp="1si835lywqqc6">
          {PRODUCT_SUBTITLE}
        </p>
        <p className="text-[12.5px] font-medium text-white/75" data-id="element-74" data-mp="1no3wl3tk0kbm">
          Regular Price: <span className="line-through" data-id="element-75" data-mp="22d032wfyppa4">{PRICE_FULL}</span>
        </p>
        <p className="mb-1.5 font-display text-[22px] font-extrabold uppercase leading-tight tracking-tight text-pf-coral sm:text-4xl" data-id="element-76" data-mp="1xeou0nxhrisy">
          🔥 TODAY ONLY: {PRICE_TODAY}
        </p>

        <CTAButton href={CHECKOUT_URL} className="mx-auto mb-1 max-w-md" data-id="element-77" data-mp="27do48axwnmi2">
          🤰 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>

        <p className="text-[11px] font-bold text-white/85 sm:text-sm" data-id="element-78" data-mp="h1rvwfxibg0e">
          Immediate Access • Digital Delivery
        </p>
        <p className="text-[11px] font-bold text-white/85 sm:text-sm" data-id="element-79" data-mp="2vy8n81adnnk">
          🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}